/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as React from 'react';

import { Link } from 'react-router-dom';
import { TenantPortalLogo } from '../../TenantPortalLogo';
import { FlexWrapper } from '../../../Shared/FlexWrapper';

import styles from './error-header.module.css';

interface ErrorLayoutHeaderProps {
    LeftComponent?: React.ReactElement;
    RightComponent?: React.ReactElement;
}

function ErrorLayoutHeader({ LeftComponent = null, RightComponent = null }): React.ReactElement<ErrorLayoutHeaderProps> {
    return (
        <FlexWrapper align="center" justify="between" className={styles.Header}>
            <div>{!!LeftComponent && LeftComponent}</div>
            <Link to="/">
                <TenantPortalLogo />
            </Link>
            <div>{!!RightComponent && RightComponent}</div>
        </FlexWrapper>
    );
}

export default ErrorLayoutHeader;
